<template lang="html">
    <div class="page" id="proLessonAvailability">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/lessons.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Weekly Availability</h2>
                <ul class="links">
                    <li>
                        <router-link class="cancel" :to="{ name: 'proLessonAvailability' }"
                            ><x-icon class="icon"
                        /></router-link>
                    </li>
                </ul>
            </header>

            <span class="info">
                Select the day and add the times you want to make available for lesson booking every
                week
            </span>

            <form class="form3" @submit.prevent="saveSettings">
                <div class="formGroup">
                    <span class="selectWrapper">
                        <select v-model="form.day" @change="changeDay">
                            <option value="0">Monday</option>
                            <option value="1">Tuesday</option>
                            <option value="2">Wednesday</option>
                            <option value="3">Thursday</option>
                            <option value="4">Friday</option>
                            <option value="5">Saturday</option>
                            <option value="6">Sunday</option>
                        </select>
                        <chevron-right-icon class="icon" />
                    </span>
                </div>

                <div class="group" v-for="(time, index) in form.times" :key="index">
                    <div class="formGroup third">
                        <div class="formGroup">
                            <!--<vue-timepicker v-model="time.start" :minute-interval="15"></vue-timepicker>-->

                            <select v-model="time.start">
                                <option value="00:00:00">00:00</option>
                                <option value="00:15:00">00:15</option>
                                <option value="00:30:00">00:30</option>
                                <option value="00:45:00">00:45</option>
                                <option value="01:00:00">01:00</option>
                                <option value="01:15:00">01:15</option>
                                <option value="01:30:00">01:30</option>
                                <option value="01:45:00">01:45</option>
                                <option value="02:00:00">02:00</option>
                                <option value="02:15:00">02:15</option>
                                <option value="02:30:00">02:30</option>
                                <option value="02:45:00">02:45</option>

                                <option value="03:00:00">03:00</option>
                                <option value="03:15:00">03:15</option>
                                <option value="03:30:00">03:30</option>
                                <option value="03:45:00">03:45</option>

                                <option value="04:00:00">04:00</option>
                                <option value="04:15:00">04:15</option>
                                <option value="04:30:00">04:30</option>
                                <option value="04:45:00">04:45</option>

                                <option value="05:00:00">05:00</option>
                                <option value="05:15:00">05:15</option>
                                <option value="05:30:00">05:30</option>
                                <option value="05:45:00">05:45</option>

                                <option value="06:00:00">06:00</option>
                                <option value="06:15:00">06:15</option>
                                <option value="06:30:00">06:30</option>
                                <option value="06:45:00">06:45</option>

                                <option value="07:00:00">07:00</option>
                                <option value="07:15:00">07:15</option>
                                <option value="07:30:00">07:30</option>
                                <option value="07:45:00">07:45</option>

                                <option value="08:00:00">08:00</option>
                                <option value="08:15:00">08:15</option>
                                <option value="08:30:00">08:30</option>
                                <option value="08:45:00">08:45</option>

                                <option value="09:00:00">09:00</option>
                                <option value="09:15:00">09:15</option>
                                <option value="09:30:00">09:30</option>
                                <option value="09:45:00">09:45</option>

                                <option value="10:00:00">10:00</option>
                                <option value="10:15:00">10:15</option>
                                <option value="10:30:00">10:30</option>
                                <option value="10:45:00">10:45</option>

                                <option value="11:00:00">11:00</option>
                                <option value="11:15:00">11:15</option>
                                <option value="11:30:00">11:30</option>
                                <option value="11:45:00">11:45</option>

                                <option value="12:00:00">12:00</option>
                                <option value="12:15:00">12:15</option>
                                <option value="12:30:00">12:30</option>
                                <option value="12:45:00">12:45</option>

                                <option value="13:00:00">13:00</option>
                                <option value="13:15:00">13:15</option>
                                <option value="13:30:00">13:30</option>
                                <option value="13:45:00">13:45</option>

                                <option value="14:00:00">14:00</option>
                                <option value="14:15:00">14:15</option>
                                <option value="14:30:00">14:30</option>
                                <option value="14:45:00">14:45</option>

                                <option value="15:00:00">15:00</option>
                                <option value="15:15:00">15:15</option>
                                <option value="15:30:00">15:30</option>
                                <option value="15:45:00">15:45</option>

                                <option value="16:00:00">16:00</option>
                                <option value="16:15:00">16:15</option>
                                <option value="16:30:00">16:30</option>
                                <option value="16:45:00">16:45</option>

                                <option value="17:00:00">17:00</option>
                                <option value="17:15:00">17:15</option>
                                <option value="17:30:00">17:30</option>
                                <option value="17:45:00">17:45</option>

                                <option value="18:00:00">18:00</option>
                                <option value="18:15:00">18:15</option>
                                <option value="18:30:00">18:30</option>
                                <option value="18:45:00">18:45</option>

                                <option value="19:00:00">19:00</option>
                                <option value="19:15:00">19:15</option>
                                <option value="19:30:00">19:30</option>
                                <option value="19:45:00">19:45</option>

                                <option value="20:00:00">20:00</option>
                                <option value="20:15:00">20:15</option>
                                <option value="20:30:00">20:30</option>
                                <option value="20:45:00">20:45</option>

                                <option value="21:00:00">21:00</option>
                                <option value="21:15:00">21:15</option>
                                <option value="21:30:00">21:30</option>
                                <option value="21:45:00">21:45</option>

                                <option value="22:00:00">22:00</option>
                                <option value="22:15:00">22:15</option>
                                <option value="22:30:00">22:30</option>
                                <option value="22:45:00">22:45</option>

                                <option value="23:00:00">23:00</option>
                                <option value="23:15:00">23:15</option>
                                <option value="23:30:00">23:30</option>
                                <option value="23:45:00">23:45</option>
                            </select>
                        </div>
                    </div>

                    <div class="formGroup third">
                        <select v-model="time.end">
                            <option value="00:00:00">00:00</option>
                            <option value="00:15:00">00:15</option>
                            <option value="00:30:00">00:30</option>
                            <option value="00:45:00">00:45</option>
                            <option value="01:00:00">01:00</option>
                            <option value="01:15:00">01:15</option>
                            <option value="01:30:00">01:30</option>
                            <option value="01:45:00">01:45</option>
                            <option value="02:00:00">02:00</option>
                            <option value="02:15:00">02:15</option>
                            <option value="02:30:00">02:30</option>
                            <option value="02:45:00">02:45</option>

                            <option value="03:00:00">03:00</option>
                            <option value="03:15:00">03:15</option>
                            <option value="03:30:00">03:30</option>
                            <option value="03:45:00">03:45</option>

                            <option value="04:00:00">04:00</option>
                            <option value="04:15:00">04:15</option>
                            <option value="04:30:00">04:30</option>
                            <option value="04:45:00">04:45</option>

                            <option value="05:00:00">05:00</option>
                            <option value="05:15:00">05:15</option>
                            <option value="05:30:00">05:30</option>
                            <option value="05:45:00">05:45</option>

                            <option value="06:00:00">06:00</option>
                            <option value="06:15:00">06:15</option>
                            <option value="06:30:00">06:30</option>
                            <option value="06:45:00">06:45</option>

                            <option value="07:00:00">07:00</option>
                            <option value="07:15:00">07:15</option>
                            <option value="07:30:00">07:30</option>
                            <option value="07:45:00">07:45</option>

                            <option value="08:00:00">08:00</option>
                            <option value="08:15:00">08:15</option>
                            <option value="08:30:00">08:30</option>
                            <option value="08:45:00">08:45</option>

                            <option value="09:00:00">09:00</option>
                            <option value="09:15:00">09:15</option>
                            <option value="09:30:00">09:30</option>
                            <option value="09:45:00">09:45</option>

                            <option value="10:00:00">10:00</option>
                            <option value="10:15:00">10:15</option>
                            <option value="10:30:00">10:30</option>
                            <option value="10:45:00">10:45</option>

                            <option value="11:00:00">11:00</option>
                            <option value="11:15:00">11:15</option>
                            <option value="11:30:00">11:30</option>
                            <option value="11:45:00">11:45</option>

                            <option value="12:00:00">12:00</option>
                            <option value="12:15:00">12:15</option>
                            <option value="12:30:00">12:30</option>
                            <option value="12:45:00">12:45</option>

                            <option value="13:00:00">13:00</option>
                            <option value="13:15:00">13:15</option>
                            <option value="13:30:00">13:30</option>
                            <option value="13:45:00">13:45</option>

                            <option value="14:00:00">14:00</option>
                            <option value="14:15:00">14:15</option>
                            <option value="14:30:00">14:30</option>
                            <option value="14:45:00">14:45</option>

                            <option value="15:00:00">15:00</option>
                            <option value="15:15:00">15:15</option>
                            <option value="15:30:00">15:30</option>
                            <option value="15:45:00">15:45</option>

                            <option value="16:00:00">16:00</option>
                            <option value="16:15:00">16:15</option>
                            <option value="16:30:00">16:30</option>
                            <option value="16:45:00">16:45</option>

                            <option value="17:00:00">17:00</option>
                            <option value="17:15:00">17:15</option>
                            <option value="17:30:00">17:30</option>
                            <option value="17:45:00">17:45</option>

                            <option value="18:00:00">18:00</option>
                            <option value="18:15:00">18:15</option>
                            <option value="18:30:00">18:30</option>
                            <option value="18:45:00">18:45</option>

                            <option value="19:00:00">19:00</option>
                            <option value="19:15:00">19:15</option>
                            <option value="19:30:00">19:30</option>
                            <option value="19:45:00">19:45</option>

                            <option value="20:00:00">20:00</option>
                            <option value="20:15:00">20:15</option>
                            <option value="20:30:00">20:30</option>
                            <option value="20:45:00">20:45</option>

                            <option value="21:00:00">21:00</option>
                            <option value="21:15:00">21:15</option>
                            <option value="21:30:00">21:30</option>
                            <option value="21:45:00">21:45</option>

                            <option value="22:00:00">22:00</option>
                            <option value="22:15:00">22:15</option>
                            <option value="22:30:00">22:30</option>
                            <option value="22:45:00">22:45</option>

                            <option value="23:00:00">23:00</option>
                            <option value="23:15:00">23:15</option>
                            <option value="23:30:00">23:30</option>
                            <option value="23:45:00">23:45</option>
                        </select>
                        <!--<vue-timepicker v-model="time.end" :minute-interval="15"></vue-timepicker>-->
                    </div>

                    <div class="formGroup third">
                        <button
                            @click.prevent="removeTime(index)"
                            class="button red"
                            type="button"
                            name="button"
                            style="
                                border-radius: 12px;
                                padding: 20px;
                                padding-top: 15px;
                                height: 49px !important;
                            "
                        >
                            <img src="~@/assets/minus.svg" />
                        </button>
                    </div>
                </div>

                <button
                    @click.prevent="addTime"
                    class="button dark mb10 left"
                    type="button"
                    name="button"
                >
                    Add availability
                    <plus-icon class="icon" />
                </button>

                <button
                    :disabled="form.busy"
                    v-if="this.form.times.length > 0"
                    class="button mb"
                    type="submit"
                    name="button"
                >
                    {{ form.busy ? "Please wait..." : "Save Settings" }}
                </button>
            </form>
            <span class="info tip">
                TIP: You can manually overide availability by selecting an individual day(s) on your
                diary
            </span>
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import { Form } from "vform";
import { XIcon, ChevronRightIcon, PlusIcon } from "vue-feather-icons";
export default {
    components: { FadeImage, XIcon, ChevronRightIcon, PlusIcon },
    watch: {
        $route() {
            this.form.times = [];
            this.getAvailability();
        },
    },
    data() {
        return {
            days: ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"],
            dayIndex: "",
            form: new Form({
                day: "",
                times: [],
            }),
        };
    },
    created() {
        this.dayIndex = this.days.findIndex((day) => {
            return day == this.$route.params.id;
        });
        if (this.dayIndex > -1) {
            this.form.day = this.dayIndex;
        }
        this.getAvailability();
    },
    methods: {
        changeDay() {
            this.$router.push({
                name: "proLessonAvailabilityDay",
                params: { id: this.days[this.form.day] },
            });
        },
        addTime() {
            this.form.times.push({
                start: "12:00:00",
                end: "13:00:00",
            });
        },
        removeTime(index) {
            this.$confirm(
                "Are you sure you want to remove this time?",
                () => {
                    this.form.times.splice(index, 1);
                    this.saveSettings();
                },
                "Yes",
                "No",
            );
        },
        getAvailability() {
            this.form.get("/recurring/availability?day=" + this.form.day).then((response) => {
                if (response.data.length > 0) {
                    response.data.forEach((availability) => {
                        this.form.times.push({
                            start: availability.start,
                            end: availability.end,
                        });
                    });
                }
            });
        },
        saveSettings() {
            this.form
                .post("/recurring/availability")
                .then(() => {
                    this.$notify({
                        duration: 1000,
                        text: "Your availability has been saved!",
                    });
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.$notify({
                            type: "error",
                            duration: 3000,
                            text: "Availability not saved! You have some times overlapping. Please adjust and resave",
                        });
                    }
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#proLessonAvailability {
    .form3 {
        select {
            background: white;
        }
        .selectWrapper {
            position: relative;
            .icon {
                position: absolute;
                right: 10px;
                top: 0px;
                color: $green_0;
                pointer-events: none;
            }
        }
        .group {
            display: flex;
            .formGroup {
                margin-right: 10px;
                margin-bottom: 10px;
                flex: 1;
                &:last-of-type {
                    flex: 0 0 50px;
                    margin-right: 0px;
                    .button {
                        padding: 15px;
                    }
                }
            }
        }
    }
}
</style>
